import { axios, axiosAuth } from "lib/axios"
import { createOrSignInFirebaseUser } from './createFirebaseUser';
import { toApiError } from './login';

export const lookupInvitation = async (token) => {
  try {
    const { data } = await axiosAuth.post("/auth/invitations/lookup", { token });
    return data;
  } catch (error) {
    throw toApiError(error);
  }
}

export const acceptInvitationNewAccount = async (data, token) => {
  await createOrSignInFirebaseUser(data.companyEmail, data.password);
  return await acceptInvitationExistingAccount(data, token);
}

export const acceptInvitationExistingAccount = async (data, token) => {
  try {
    return await axios.post("/auth/accept-invitation", {
      token,
      user: {
        first_name: data.firstName,
        last_name: data.lastName,
        phone_number: data.phoneNumber,
      },
    });
  } catch (error) {
    throw toApiError(error);
  }
}

export const acceptPendingInvitation = async (userID) => {
  try {
    return await axios.post("/auth/accept-invitation", { user_id: userID });
  } catch (error) {
    throw toApiError(error);
  }
}
